export { default } from './AvisButlletins';
